import styles from "./Skills.module.css";
import React, { useEffect, useState } from "react";

import { SKILLS } from "../../utils/app-content";

import { SectionTitle } from "../../components/SectionTitle/SectionTitle";
import { SkillContent } from "../../components/SkillContent/SkillContent";
import { Section } from "../../layout/Section/Section";
import { Container } from "../../layout/Container/Container";

export const Skills = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const changeActiveIndex = (index) => {
    if (activeIndex === index) setActiveIndex(null);
    else setActiveIndex(index);
  };

  return (
    <Section id="skills">
      <SectionTitle title="Skills" subtitle="Technical Level" />
      <Container className={`${styles.container} grid`}>
        {SKILLS.map((skill, index) => (
          <SkillContent
            index={index}
            key={index}
            skill={skill}
            isActiveIndex={activeIndex === index}
            changeActiveIndex={changeActiveIndex}
          />
        ))}
      </Container>
    </Section>
  );
};
